<template>
  <template v-for="(field, index) in state.addressFields" :key="index">
    <hr-co-input
      v-if="field.name !== 'administrativeArea'"
      v-bind="$attrs"
      :value="field.value"
      :label="field.label"
      :disabled="field.name === 'regionCode'"
      :invalid="field.isInvalid"
      :type="field.theType"
      class="HRField HRField__hr-co-input"
      @blur="(value) => updateAddressFields(value, index)"
      @focus="$emit('focus')"
      @input="$emit('input')"
      :data-test-id="`hr-manual-address-${field.name.toLowerCase()}`"
    >
      <template v-slot:invalid class="HRField__invalid">{{
        field.validation.errorMessage
      }}</template>
    </hr-co-input>
    <hr-select
      v-else
      v-bind="$attrs"
      :value="field.value"
      :label="field.label"
      :list="field.list"
      :invalid="field.isInvalid"
      :errorMessage="field.validation.errorMessage"
      class="HRField"
      @update:value="changeState"
      @blur="blur"
      @focus="$emit('focus')"
      @input="$emit('input')"
    >
      <template v-slot:invalid class="HRField__invalid">{{
        field.validation.errorMessage
      }}</template>
    </hr-select>
  </template>
</template>

<script>
import HrCoInput from '@/components/hr-co-input.vue';
import HrSelect from '@/components/hr-select.vue';
import { reactive } from 'vue';
import { validate } from '@/core/validation/validation';
import { updateManualAddressFields } from '@/components/common/manual-address';
import cloneObj from '@/core/cloneObj';

export default {
  name: 'hr-manual-address',
  components: {
    HrSelect,
    HrCoInput,
  },
  emits: ['update:model-value', 'focus', 'blur'],
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
    },
    addressFields: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const state = reactive({
      field: props.modelValue,
      theType: 'STRING',
      addressFields: cloneObj(props.addressFields),
      isAddressFieldsVisible: false,
    });

    function trimAddressValues() {
      if (state.field.valueObj) {
        const {
          addressLines,
          administrativeArea,
          locality,
          postalCode,
          regionCode,
        } = state.field.valueObj;

        state.field.valueObj = {
          addressLines: addressLines.map((line) => line.trim()),
          administrativeArea: administrativeArea.trim(),
          locality: locality.trim(),
          postalCode: postalCode.trim(),
          regionCode: regionCode.trim(),
        };
      }

      if (state.field.value) {
        state.field.value = state.field.value.trim()?.replace(/\s+/g, ' ');
      }
    }

    async function input() {
      // add a green tick in non restricted fields
      if (!state.field.validation.validator) {
        state.field.isInvalid = state.field.value ? false : null;
      }

      if (!state.field.value) {
        state.field.isInvalid = null;
      }

      trimAddressValues();

      emit('update:model-value', state.field);
    }

    function updateAddressFields(value, index) {
      updateManualAddressFields(value, index, state);
      input();
    }

    function blur(value, obj) {
      state.field.value = value;
      state.field.valueObj = obj;
      input();
      validate(state.field);
    }

    function changeState(value, obj) {
      updateAddressFields(obj.code, 2);
    }
    return {
      state,
      updateAddressFields,
      blur,
      changeState,
    };
  },
};
</script>

<style lang="scss"></style>
